/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cursus.rpc.SendConfigurationRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */
export type ChirpVoid = {};

export type PortalUnsubscribeLinkSettingRequest = {
  portalUnsubscribeLinkEnabled: boolean;
  unsubscribeLinkType?: UnsubscribeLinkType;
};

export type SendAsSetting = {
  portalId: number;
  userId: number;
  inboxId: number;
  emailAddress: string;
  displayName?: string;
  signature?: string;
  default: Default<boolean>;
  primary: Default<boolean>;
  deleted: Default<boolean>;
  createdAt: Default<number>;
  updatedAt: Default<number>;
};

export type SendAsSettingsResponse = { settings: Default<SendAsSetting[]> };

export type UnsubscribeLinkSettingResponse = {
  portalUnsubscribeLinkEnabled: boolean;
  unsubscribeLinkType?: UnsubscribeLinkType;
};

export type UnsubscribeLinkType =
  | 'RELEVANT'
  | 'STOP_GETTING_MESSAGES'
  | 'PREFER_LESS'
  | 'NO_UNSUBSCRIBE_LINK'
  | unhandledEnumCase;

export type SendConfigurationError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type DeleteSendAsSettingsRequest = {
  inboxId: number;
  emailAddress: string;
};

export type GetSendAsSettingsForUserResponseType = SendAsSettingsResponse;
export type GetSendAsSettingsForUserErrorType = EmptyError & HubspotMetadata;
export const getSendAsSettingsForUserRpc: ChirpAvroRpcDetails<
  undefined,
  GetSendAsSettingsForUserResponseType,
  GetSendAsSettingsForUserErrorType,
  false
> = {
  serviceName: 'com.hubspot.cursus.rpc.SendConfigurationRpc',
  rpcName: 'getSendAsSettingsForUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAXvDAnIZJ0KpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPortalUnsubscribeLinkSettingsResponseType =
  UnsubscribeLinkSettingResponse;
export type GetPortalUnsubscribeLinkSettingsErrorType = EmptyError &
  HubspotMetadata;
export const getPortalUnsubscribeLinkSettingsRpc: ChirpAvroRpcDetails<
  undefined,
  GetPortalUnsubscribeLinkSettingsResponseType,
  GetPortalUnsubscribeLinkSettingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.cursus.rpc.SendConfigurationRpc',
  rpcName: 'getPortalUnsubscribeLinkSettings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAASXMIG7TGyrJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetUserUnsubscribeLinkSettingsResponseType =
  UnsubscribeLinkSettingResponse;
export type GetUserUnsubscribeLinkSettingsErrorType = EmptyError &
  HubspotMetadata;
export const getUserUnsubscribeLinkSettingsRpc: ChirpAvroRpcDetails<
  undefined,
  GetUserUnsubscribeLinkSettingsResponseType,
  GetUserUnsubscribeLinkSettingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.cursus.rpc.SendConfigurationRpc',
  rpcName: 'getUserUnsubscribeLinkSettings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAASXMIG7TGyrJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SetPortalUnsubscribeLinkSettingsRequestType =
  Requestify<PortalUnsubscribeLinkSettingRequest>;
export type SetPortalUnsubscribeLinkSettingsResponseType = ChirpVoid;
export type SetPortalUnsubscribeLinkSettingsErrorType = EmptyError &
  HubspotMetadata;
export const setPortalUnsubscribeLinkSettingsRpc: ChirpAvroRpcDetails<
  SetPortalUnsubscribeLinkSettingsRequestType,
  SetPortalUnsubscribeLinkSettingsResponseType,
  SetPortalUnsubscribeLinkSettingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.cursus.rpc.SendConfigurationRpc',
  rpcName: 'setPortalUnsubscribeLinkSettings',
  auth: 'app',
  fingerprint: 'jz29niGZIkWOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteSendAsSettingsRequestType =
  Requestify<DeleteSendAsSettingsRequest>;
export type DeleteSendAsSettingsResponseType = ChirpVoid;
export type DeleteSendAsSettingsErrorType = SendConfigurationError &
  HubspotMetadata;
export const deleteSendAsSettingsRpc: ChirpAvroRpcDetails<
  DeleteSendAsSettingsRequestType,
  DeleteSendAsSettingsResponseType,
  DeleteSendAsSettingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.cursus.rpc.SendConfigurationRpc',
  rpcName: 'deleteSendAsSettings',
  auth: 'app',
  fingerprint: 'xTHWURVwJxGOUe2e_r4XmWGeNmH3ZPI0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
